import React from 'react'
// Components
import * as domBridge from '../Services/domBridge.jsx'
import * as storage from '../Services/storage.jsx'
import {decodeJwt} from '../Services/helpers.jsx'
import LoginModal from './LoginModal.jsx'
import ForgotPasswordModal from './ForgotPasswordModal.jsx'
import {UserMenu} from './UserMenu.jsx'
import {createRoot} from 'react-dom/client'
// Services

export default class LoginAndForgotPasswordWrapper extends React.Component {
  constructor(props) {
    super(props)

    const search = Object.fromEntries(
      new URLSearchParams(window.location.search),
    )

    this.state = {
      isLoginModalVisible: props.isVisible || false,
      isForgotPasswordModalVisible: search['recover-password'] == 1,
      isMobile: window.innerWidth <= 768,
    }
  }

  showLoginModal = () => {
    this.setState({isLoginModalVisible: true}, function () {
      domBridge.addPreventScrollUnderModal()
    })
  }

  hideLoginModal = () => {
    this.setState(
      {isLoginModalVisible: false},
      () => {
        domBridge.removePreventScrollUnderModal()
        // Notifica il componente padre che il modale è stato chiuso
        if (this.props.onModalClose) {
          this.props.onModalClose();
        }
      }
    )
  }

  onLogin = (userToken) => {
    this.hideLoginModal()
    storage.storeCurrentUserToken(userToken)
    domBridge.hideSignInButton()
    
    // Controlla se siamo su mobile
    const isMobile = window.innerWidth <= 768;
    const shouldHideElements = isMobile;
    
    const userInfoDomElement = document.getElementById('userInfo')
    if (userInfoDomElement && !shouldHideElements) {
      const container = createRoot(userInfoDomElement)
      const user = decodeJwt(userToken)
      container.render(<UserMenu user={user} />)
    } else if (userInfoDomElement && shouldHideElements) {
      // Nascondi il contenuto se mobile
      userInfoDomElement.innerHTML = '';
    } else {
      console.error('userInfo element not found!');
    }
    // Evento custom per aggiornare lo stato in App.jsx
    window.dispatchEvent(new CustomEvent('user-login', { detail: { token: userToken } }));
  }

  onForgotPasswordClick = () => {
    this.hideLoginModal()
    this.showForgotPasswordModal()
  }

  showForgotPasswordModal = () => {
    this.setState({isForgotPasswordModalVisible: true}, function () {
      domBridge.addPreventScrollUnderModal()
    })
  }

  hideForgotPasswordModal = () => {
    this.setState(
      {isForgotPasswordModalVisible: false},
      domBridge.removePreventScrollUnderModal,
    )
  }

  onBackToSignginClick = () => {
    this.hideForgotPasswordModal()
    this.showLoginModal()
  }

  componentDidMount = () => {
    this.setupSignInListener()
    domBridge.showHeaderUserInfoDomElement()

    // Listener per resize
    this.handleResize = () => {
      const newIsMobile = window.innerWidth <= 768;
      this.setState({ isMobile: newIsMobile });
      
      // Riapplica il listener quando cambia la visibilità del bottone
      this.setupSignInListener();
      
      // Aggiorna il UserMenu se l'utente è loggato
      const storedUserToken = storage.getCurrentUserToken();
      if (storedUserToken) {
        const userInfoDomElement = document.getElementById('userInfo');
        if (userInfoDomElement) {
          if (newIsMobile) {
            // Nascondi il contenuto se mobile
            userInfoDomElement.innerHTML = '';
          } else {
            // Ricrea il UserMenu se non è mobile
            const container = createRoot(userInfoDomElement);
            const user = decodeJwt(storedUserToken);
            container.render(<UserMenu user={user} />);
          }
        }
      }
    };
    window.addEventListener('resize', this.handleResize);

    const storedUserToken = storage.getCurrentUserToken()
    if (storedUserToken) {
      this.onLogin(storedUserToken)
    }
  }

  componentDidUpdate = (prevProps) => {
    // Se la prop isVisible cambia, aggiorna lo stato del modale
    if (prevProps.isVisible !== this.props.isVisible) {
      this.setState({ isLoginModalVisible: this.props.isVisible }, () => {
        // Quando il modale si apre via prop isVisible (percorso usato da
        // AppLoginMobile e AppLogin), replica gli effetti di showLoginModal:
        // blocca lo scroll sotto e — su mobile — vincola l'altezza del
        // contenuto così il footer col bottone resta sempre visibile.
        if (this.props.isVisible) {
          domBridge.addPreventScrollUnderModal()
        } else {
          domBridge.removePreventScrollUnderModal()
        }
      });
    }
  }

  setupSignInListener = () => {
    // Rimuovi il listener esistente prima di aggiungerne uno nuovo
    domBridge.stopListeningSignInClick(this.showLoginModal)
    // Non registrare listener per evitare conflitti con AppLoginMobile
  }

  componentWillUnmount = () => {
    if (this.handleResize) {
      window.removeEventListener('resize', this.handleResize);
    }
    domBridge.stopListeningSignInClick(this.showLoginModal)
  }

  render = () => {
    const {isLoginModalVisible, isForgotPasswordModalVisible} = this.state
    console.log('LoginAndForgotPasswordWrapper render:', { isLoginModalVisible, isForgotPasswordModalVisible, props: this.props });
    return (
      <div className={'login-and-forgot-password-wrapper'}>
        {isLoginModalVisible && (
          <LoginModal
            onDismiss={this.hideLoginModal}
            onLogin={this.onLogin}
            onForgotPasswordClick={this.onForgotPasswordClick}
          />
        )}
        {isForgotPasswordModalVisible && (
          <ForgotPasswordModal
            onDismiss={this.hideForgotPasswordModal}
            onBackToSignginClick={this.onBackToSignginClick}
          />
        )}
      </div>
    )
  }
}
